<div class="pkg-filter">
  <!-- Content -->
  <div class="pkg-filter__body">
    <p class="pkg-filter__intro">
      Find prices by exact ID or narrow the list with filters.
    </p>
    <!-- Search by code — exact match, OR-ed; mutually exclusive with the
         toolbar's free-text search (applying a code clears the text search). -->
    <details class="pkg-filter__group" open>
      <summary class="pkg-filter__summary">
        <span
          ><strong>Search by ID</strong
          ><span class="pkg-filter__subtitle"
            >Offering, price or product identifiers</span
          ></span
        >
      </summary>
      <div class="pkg-filter__section-body">
        <p class="pkg-filter__hint pkg-filter__guidance">
          Paste one or more exact IDs. Separate values with commas or new lines.
        </p>
        @if (searchActive) {
        <p class="pkg-filter__notice" role="status">
          Applying an ID search will replace the current text search.
        </p>
        }

        <div class="space-y-4">
          <div>
            <!-- Textareas, like the product code field below: a single-line
               input strips the new lines out of a pasted spreadsheet column
               and fuses the ids. -->
            <enr-textarea
              label="Offering ID"
              placeholder="e.g. V1StGXRZ5j3, a1b2c3d4e5f"
              [rows]="2"
              [(ngModel)]="filterData.offeringCode"
            ></enr-textarea>

            <p class="pkg-filter__hint">
              Exact Offering IDs; spaces also separate multiple IDs.
            </p>
          </div>

          <div>
            <enr-textarea
              label="Price ID"
              placeholder="e.g. enrpop260600060, enrpop260600061"
              [rows]="2"
              [(ngModel)]="filterData.priceId"
            ></enr-textarea>

            <p class="pkg-filter__hint">
              Returns exactly these prices, one row for each package that lists
              them.
            </p>
          </div>

          <div>
            <enr-textarea
              label="Product code / number"
              placeholder="e.g. O210409863168, P100012345"
              [rows]="2"
              [(ngModel)]="filterData.productRefs"
            ></enr-textarea>

            <p class="pkg-filter__hint">
              <strong>O</strong> = Product Code · <strong>P</strong> = Product
              Number. Use the complete code.
            </p>
          </div>
        </div>
      </div>
    </details>

    <!-- Filters — the attributes GET /api/v1/enrichment can filter on. -->
    <details class="pkg-filter__group" open>
      <summary class="pkg-filter__summary">
        <span
          ><strong>Package filters</strong
          ><span class="pkg-filter__subtitle"
            >Product details, status and availability</span
          ></span
        >
      </summary>
      <div class="pkg-filter__section-body">
        <div class="space-y-4">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <enr-select
              label="Product type"
              placeholder="Any product type"
              [options]="productTypeOptions"
              [(ngModel)]="filterData.productType"
            ></enr-select>
            <enr-input
              label="Product line"
              placeholder="Enter product line"
              [(ngModel)]="filterData.productLine"
            ></enr-input>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <enr-select
              label="Version"
              placeholder="Any version"
              [options]="versionOptions"
              [(ngModel)]="filterData.version"
            ></enr-select>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <enr-select
              label="Package status"
              placeholder="Any package status"
              [options]="lifecycleStatusOptions"
              [(ngModel)]="filterData.lifecycleStatus"
            ></enr-select>
            <enr-select
              label="Sellable"
              placeholder="Any availability"
              [options]="isSellableOptions"
              [(ngModel)]="filterData.isSellable"
            ></enr-select>
          </div>

          <!-- The whole card is the target, not just the box — same pattern as
             the reject drawer's price rows. The checkbox stops its own click
             so the card handler can't immediately undo it. -->
          <div
            class="pkg-filter__deleted"
            [class.is-checked]="deletedChecked"
            role="button"
            tabindex="0"
            [attr.aria-pressed]="deletedChecked"
            aria-label="Deleted packages"
            data-testid="enrichment-filter-deleted-card"
            (click)="toggleDeleted()"
            (keydown.enter)="toggleDeleted(); $event.preventDefault()"
            (keydown.space)="toggleDeleted(); $event.preventDefault()"
          >
            <enr-checkbox
              [(ngModel)]="deletedChecked"
              data-testid="enrichment-filter-deleted-check"
              (click)="$event.stopPropagation()"
            ></enr-checkbox>
            <div class="flex flex-col">
              <span class="pkg-filter__deleted-title">Deleted packages</span>
              <span class="pkg-filter__deleted-hint"
                >Shows only deleted packages. Active offerings appear with just
                their deleted packages.</span
              >
            </div>
          </div>
        </div>
      </div>
    </details>
  </div>

  <!-- Footer — flush to the drawer edges (negative margins cancel the drawer
       content's 24px padding) so the divider spans full width and the bar docks
       at the bottom; px-6 keeps the buttons aligned with the body fields. -->
  <div class="pkg-filter__footer">
    <span class="pkg-filter__footer-hint"
      >Clear all resets the current filters immediately.</span
    >
    <div class="pkg-filter__actions">
      <enr-button variant="outline" size="medium" (clicked)="onClearAll()">
        Clear all
      </enr-button>
      <enr-button variant="primary" size="medium" (clicked)="onApply()">
        Show results
      </enr-button>
    </div>
  </div>
</div>
